import { render, staticRenderFns } from "./EditEmail.vue?vue&type=template&id=7bb49d03&scoped=true&"
import script from "./EditEmail.vue?vue&type=script&lang=ts&"
export * from "./EditEmail.vue?vue&type=script&lang=ts&"
import style0 from "./EditEmail.vue?vue&type=style&index=0&id=7bb49d03&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bb49d03",
  null
  
)

export default component.exports